import React, { useEffect, useState } from 'react';
import { locales } from '../../../translations/locales';
import { FaChevronRight } from 'react-icons/fa6';

const Places = (props) => {
    const { locale, theme, places, onChangeQualification } = props;
    const [placeCategory, setPlaceCategory] = useState('');
    const [placeType, setPlaceType] = useState('');

    useEffect(() => {
        if (placeType) {
            onChangeQualification({ target: { id: 'place', value: { category: placeCategory, type: placeType } } });
        }
    }, [placeType]);

    return (
        <div className={`row m-2 alert alert-${theme === 'DARK' ? 'dark' : 'light'}`}>
            <div className='col-4'>
                {
                    Object.keys(places).map((place, index) => (
                        <div key={index} className='row'>
                            <div className='col-12'>
                                <div
                                    className={`text-left cursor-pointer ${placeCategory === place ? 'alert alert-success p-1' : ''}`}
                                    onClick={() => setPlaceCategory(place)}>
                                    <span>
                                        {locales[locale].sig[place]}
                                        <FaChevronRight className='mb-1' />
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
            <div
                className='col-4 overflow-auto '
                style={{ height: '200px' }}
            >
                {
                    placeCategory && places[placeCategory].types.map((type, index) => (
                        <div key={index} className='row'>
                            <div className='col-12'>
                                <div
                                    className={`text-left cursor-pointer ${placeType === type ? 'alert alert-success p-1' : ''}`}
                                    onClick={() => setPlaceType(type)}
                                >
                                    <span>{locales[locale].sig[type]}</span>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default Places;
